module.exports = __webpack_public_path__ + "img/wedding-background.ec3acb03.jpeg";